import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { internalChatEndpoint } from "@/config/endpoints";

/**
 * Wipes the current user's Messages dropdown — per-user only, other
 * participants still see their copies. Threads re-surface the moment any
 * new message arrives (the server filters by `createdAt > clearedAt`).
 */
export function useClearChatThreads() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await axiosInstance.post(`${internalChatEndpoint}/clear`);
      return res.data as { status: string; clearedAt: string };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["chat-threads"] });
      qc.invalidateQueries({ queryKey: ["chat-unread-count"] });
    },
  });
}
